import { CommonLookupItem } from '../../shared/models/common-lookup-item.model';
import { LookupService } from '../../shared/services/lookup.service';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { RangeFilter } from '../../shared/models/range.model';
import { StatsAndReportsService } from '../shared/services/stats-and-reports.service';
import { AnnouncementsTotalPerCustomerListModel } from '../shared/models/announcements-total-per-customer-list-model';
import {
  AnnouncementsTotalsPerCustomerFilter,
  DateEnum,
} from '../shared/models/announcements-totals-per-customer-filter';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hr-announcements-totals-per-customer',
  templateUrl: './announcements-totals-per-customer.component.html',
  styleUrls: ['./announcements-totals-per-customer.component.less'],
  standalone: false,
})
export class AnnouncementsTotalsPerCustomerComponent implements OnInit {
  public announcementsTotalsPerCustomerFilter: AnnouncementsTotalsPerCustomerFilter;
  public announcementsTotalPerCustomerListModel: AnnouncementsTotalPerCustomerListModel;
  public providerWebsiteList: CommonLookupItem<number, string>[];
  public dateEnum: DateEnum;
  public DateEnum: any = DateEnum;
  public specialDateFormat: string;
  public dateFormat: string;

  constructor(
    private statsAndReportsService: StatsAndReportsService,
    private config: ConfigurationService,
    private lookupService: LookupService
  ) {
    this.announcementsTotalsPerCustomerFilter =
      new AnnouncementsTotalsPerCustomerFilter();
    this.providerWebsiteList = [];
  }

  public getSpecialDateFormat(format: string) {
    return format.replace('MM', 'mm').replace('yyyy', 'yy');
  }

  public applyFilter() {
    this.statsAndReportsService
      .getAnnouncementsTotalsPerCustomer(
        this.announcementsTotalsPerCustomerFilter
      )
      .subscribe((s) => {
        this.announcementsTotalPerCustomerListModel = s;
      });
  }

  //TODO: Implementation
  public sortAsc() {}

  //TODO: Implementation
  public sortDesc() {}

  ngOnInit() {
    this.announcementsTotalsPerCustomerFilter.group = 1;
    this.announcementsTotalsPerCustomerFilter.providerWebsiteId = null;
    let lookupData = this.lookupService.getCachedLookupData();
    this.providerWebsiteList = lookupData.providerWebsiteList;
    let config = this.config.getCachedConfig();
    this.dateFormat = config.dateFormat;
    this.specialDateFormat = this.getSpecialDateFormat(this.dateFormat);
  }
}
